/**
 * Bundle Discount Selector
 * Handles tier selection, quantity syncing, and cart discount messaging.
 * Includes progress bar for upselling.
 */
(function () {
  'use strict';

  function initBundleSelectors() {
    var selectors = document.querySelectorAll('[data-bundle-selector]');
    selectors.forEach(function (selector) {
      setupSelector(selector);
    });

    // Also add discount messaging to cart page
    if (document.querySelector('.template-cart')) {
      updateCartDiscountMessage();
    }
  }

  function setupSelector(container) {
    var tiers = container.querySelectorAll('[data-bundle-tier]');
    var radios = container.querySelectorAll('[data-bundle-radio]');
    // Find the quantity input in the same product form
    var form = container.closest('.product-form') || container.closest('form');
    var quantityInput = form
      ? form.querySelector('.product-quantity-input') || form.querySelector('input[name="quantity"]')
      : null;

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var tier = radio.closest('[data-bundle-tier]');
        var qty = parseInt(tier.getAttribute('data-quantity'), 10);

        // Update active state
        tiers.forEach(function (t) {
          t.classList.remove('bundle-tier--active');
        });
        tier.classList.add('bundle-tier--active');

        // Sync quantity input
        if (quantityInput) {
          quantityInput.value = qty;
          var event = new Event('change', { bubbles: true });
          quantityInput.dispatchEvent(event);
        }
      });
    });

    // Allow clicking the whole tier label area
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        var radio = tier.querySelector('[data-bundle-radio]');
        if (radio && !radio.checked) {
          radio.checked = true;
          var event = new Event('change', { bubbles: true });
          radio.dispatchEvent(event);
        }
      });
    });

    // Sync when quantity input changes manually
    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        syncTierFromQuantity(container, parseInt(quantityInput.value, 10));
      });
      quantityInput.addEventListener('input', function () {
        syncTierFromQuantity(container, parseInt(quantityInput.value, 10));
      });
    }
  }

  function syncTierFromQuantity(container, qty) {
    var tiers = container.querySelectorAll('[data-bundle-tier]');
    var bestMatch = null;

    tiers.forEach(function (tier) {
      var tierQty = parseInt(tier.getAttribute('data-quantity'), 10);
      if (qty >= tierQty) {
        bestMatch = tier;
      }
    });

    if (bestMatch) {
      tiers.forEach(function (t) {
        t.classList.remove('bundle-tier--active');
      });
      bestMatch.classList.add('bundle-tier--active');
      var radio = bestMatch.querySelector('[data-bundle-radio]');
      if (radio) radio.checked = true;
    }
  }

  /**
   * Cart page: show discount messaging with progress bar.
   */
  function updateCartDiscountMessage() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var totalItems = cart.item_count;
        var messageContainer = document.querySelector('[data-bundle-cart-message]');
        if (!messageContainer) return;

        if (totalItems === 1) {
          messageContainer.innerHTML =
            '<div class="bundle-cart-upsell">' +
              '<span class="bundle-cart-upsell__icon">&#9889;</span>' +
              '<div>' +
                '<span>Add <strong>1 more</strong> to save <strong>10%</strong> on your order!</span>' +
                '<div class="bundle-progress"><div class="bundle-progress__bar" style="width: 33%"></div></div>' +
              '</div>' +
            '</div>';
          messageContainer.style.display = 'block';
        } else if (totalItems === 2) {
          messageContainer.innerHTML =
            '<div class="bundle-cart-upsell">' +
              '<span class="bundle-cart-upsell__icon">&#9889;</span>' +
              '<div>' +
                '<span>You\'re saving <strong>10%</strong>! Add <strong>1 more</strong> to save <strong>15%</strong>.</span>' +
                '<div class="bundle-progress"><div class="bundle-progress__bar" style="width: 66%"></div></div>' +
              '</div>' +
            '</div>';
          messageContainer.style.display = 'block';
        } else if (totalItems >= 3) {
          messageContainer.innerHTML =
            '<div class="bundle-cart-confirm">' +
              '<span class="bundle-cart-confirm__icon">&#10003;</span>' +
              '<div>' +
                '<span><strong>15% discount</strong> applied — best value!</span>' +
                '<div class="bundle-progress"><div class="bundle-progress__bar" style="width: 100%"></div></div>' +
              '</div>' +
            '</div>';
          messageContainer.style.display = 'block';
        } else {
          messageContainer.style.display = 'none';
        }
      })
      .catch(function () {
        // Silently fail
      });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleSelectors);
  } else {
    initBundleSelectors();
  }
})();
